// ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ lenis }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      if (lenis) {
        // Reset Lenis scroll position
        lenis.scrollTo(0, { immediate: true });

        // Ensure Lenis scrolls correctly with animation frame
        requestAnimationFrame(() => lenis.raf(performance.now()));
      } else {
        // Fallback to default scroll behavior
        window.scrollTo(0, 0);
      }
    };

    scrollToTop();

    // Optional: further delay if rendering timing causes inconsistency
    const timeout = setTimeout(scrollToTop, 100);

    return () => clearTimeout(timeout);
  }, [pathname, lenis]);

  return null;
};

export default ScrollToTop;
